<!-- Loading State -->
<div class="inventory-container" *ngIf="loading">
  <div class="loading-state">
    <div class="loading-spinner"></div>
    <p>Loading content inventory…</p>
  </div>
</div>

<!-- Error State -->
<div class="inventory-container" *ngIf="!loading && error">
  <div class="error-state">
    <div class="error-icon">⚠️</div>
    <h2>Something went wrong</h2>
    <p>{{ error }}</p>
    <button class="btn-primary" (click)="loadInventory()">Try Again</button>
  </div>
</div>

<!-- Empty State (no pages analyzed yet) -->
<div class="inventory-container" *ngIf="isEmpty">
  <div class="empty-state">
    <div class="empty-icon">📋</div>
    <h1>No pages analyzed yet</h1>
    <p class="empty-subtitle">Run a page comparison to start building your content inventory.</p>
    <a routerLink="/page-comparison" class="btn-primary btn-lg">Compare Two Pages</a>
  </div>
</div>

<!-- Content (has data) -->
<div class="inventory-container" *ngIf="!loading && !error && !isEmpty">
  <header class="inventory-header">
    <div class="header-text">
      <h1>Content Inventory</h1>
      <p class="header-subtitle">{{ pagination.total }} analyzed page{{ pagination.total === 1 ? '' : 's' }}</p>
    </div>
  </header>

  <!-- Search & Controls -->
  <div class="controls-bar">
    <div class="search-box">
      <span class="search-icon">🔍</span>
      <input
        type="text"
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearchChange()"
        placeholder="Search by URL…"
        class="search-input"
      />
    </div>
  </div>

  <!-- No results for search -->
  <div class="empty-search" *ngIf="isEmptySearch">
    <p>No pages match "<strong>{{ searchQuery }}</strong>"</p>
    <button class="btn-secondary" (click)="searchQuery = ''; onSearchChange()">Clear search</button>
  </div>

  <!-- Table -->
  <div class="table-wrapper" *ngIf="pages.length > 0">
    <table class="inventory-table">
      <thead>
        <tr>
          <th class="col-url sortable" (click)="toggleSort('url')">
            URL{{ sortIcon('url') }}
          </th>
          <th class="col-score sortable" (click)="toggleSort('onpageScore')">
            Score{{ sortIcon('onpageScore') }}
          </th>
          <th class="col-words sortable" (click)="toggleSort('wordCount')">
            Words{{ sortIcon('wordCount') }}
          </th>
          <th class="col-status sortable" (click)="toggleSort('statusCode')">
            Status{{ sortIcon('statusCode') }}
          </th>
          <th class="col-issues">Issues</th>
          <th class="col-topics">Topics</th>
          <th class="col-keywords">Keywords</th>
          <th class="col-date sortable" (click)="toggleSort('analyzedAt')">
            Analyzed{{ sortIcon('analyzedAt') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let page of pages" class="page-row" (click)="goToUrlDetail(page.url)">
          <td class="col-url" [title]="page.url">
            <span class="url-text">{{ formatUrl(page.url) }}</span>
          </td>
          <td class="col-score">
            <span class="score-badge" [ngClass]="scoreClass(page.onpageScore)">
              {{ page.onpageScore }}
            </span>
          </td>
          <td class="col-words">{{ page.wordCount | number }}</td>
          <td class="col-status">
            <span class="status-badge" [ngClass]="statusCodeClass(page.statusCode)">
              {{ page.statusCode }}
            </span>
          </td>
          <td class="col-issues">
            <span class="issues-badge" [ngClass]="issuesClass(page.criticalIssuesCount, page.warningsCount)">
              <ng-container *ngIf="page.criticalIssuesCount > 0">
                {{ page.criticalIssuesCount }} critical
              </ng-container>
              <ng-container *ngIf="page.criticalIssuesCount > 0 && page.warningsCount > 0">, </ng-container>
              <ng-container *ngIf="page.warningsCount > 0">
                {{ page.warningsCount }} warning{{ page.warningsCount === 1 ? '' : 's' }}
              </ng-container>
              <ng-container *ngIf="page.criticalIssuesCount === 0 && page.warningsCount === 0">
                ✓ Clean
              </ng-container>
            </span>
          </td>
          <td class="col-topics">{{ page.topicSignalsCount || '—' }}</td>
          <td class="col-keywords">{{ page.rankedKeywordsCount || '—' }}</td>
          <td class="col-date">{{ timeAgo(page.analyzedAt) }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <div class="pagination" *ngIf="pagination.totalPages > 1">
    <button
      class="page-btn"
      [disabled]="pagination.page <= 1"
      (click)="goToPage(pagination.page - 1)"
    >← Prev</button>

    <span class="page-info">
      Page {{ pagination.page }} of {{ pagination.totalPages }}
    </span>

    <button
      class="page-btn"
      [disabled]="pagination.page >= pagination.totalPages"
      (click)="goToPage(pagination.page + 1)"
    >Next →</button>
  </div>
</div>
